import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemContainer } from './styles';
export const ListItem = ({ children, style }) => {
    return (_jsx("div", { children: _jsx(ListItemContainer, { style: Object.assign({ marginBottom: 32, alignSelf: 'stretch', height: '100%' }, style), children: children }) }));
};
